export interface PermissionsData {
    id?: number;
    permission: string;
    users?: any;
    module_name: string;
    metadata?: string[];
}

export enum Permissions {
    NO_VALIDATE = 'NO_VALIDATE',
    FORM_BUILDER = 'FORM_BUILDER',
    FORM_BUILDER_READ = 'FORM_BUILDER_READ',
    FORM_BUILDER_EDIT = 'FORM_BUILDER_EDIT',
    FORM_BUILDER_CREATE = 'FORM_BUILDER_CREATE',
    FORM_BUILDER_DELETE = 'FORM_BUILDER_DELETE',
    SBX_STUDIO_AGENT_V2 = 'SBX_STUDIO_AGENT_V2',
    SBX_STUDIO_AGENT_V2_READ = 'SBX_STUDIO_AGENT_V2_READ',
    SBX_STUDIO_AGENT_V2_EDIT = 'SBX_STUDIO_AGENT_V2_EDIT',
    SBX_STUDIO_AGENT_V2_CREATE = 'SBX_STUDIO_AGENT_V2_CREATE',
    SBX_STUDIO_AGENT_V2_DELETE = 'SBX_STUDIO_AGENT_V2_DELETE',
    SBX_STUDIO_AGENT_V2_EXECUTE = 'SBX_STUDIO_AGENT_V2_EXECUTE',

    SBX_STUDIO_AGENT_V3 = 'SBX_STUDIO_AGENT_V3',
    SBX_STUDIO_AGENT_V3_READ = 'SBX_STUDIO_AGENT_V3_READ',
    SBX_STUDIO_AGENT_V3_EDIT = 'SBX_STUDIO_AGENT_V3_EDIT',
    SBX_STUDIO_AGENT_V3_CREATE = 'SBX_STUDIO_AGENT_V3_CREATE',
    SBX_STUDIO_AGENT_V3_DELETE = 'SBX_STUDIO_AGENT_V3_DELETE',
    SBX_STUDIO_AGENT_V3_EXECUTE = 'SBX_STUDIO_AGENT_V3_EXECUTE',

    SBX_STUDIO_AGENT = 'SBX_STUDIO_AGENT',
    SBX_STUDIO_AGENT_READ = 'SBX_STUDIO_AGENT_READ',
    SBX_STUDIO_AGENT_EDIT = 'SBX_STUDIO_AGENT_EDIT',
    SBX_STUDIO_AGENT_CREATE = 'SBX_STUDIO_AGENT_CREATE',
    SBX_STUDIO_AGENT_DELETE = 'SBX_STUDIO_AGENT_DELETE',
    SBX_STUDIO_AGENT_EXECUTE = 'SBX_STUDIO_AGENT_EXECUTE',

    SBX_STUDIO_DOCUMENT = 'SBX_STUDIO_DOCUMENT',
    SBX_STUDIO_DOCUMENT_READ = 'SBX_STUDIO_DOCUMENT_READ',
    SBX_STUDIO_DOCUMENT_EDIT = 'SBX_STUDIO_DOCUMENT_EDIT',
    SBX_STUDIO_DOCUMENT_CREATE = 'SBX_STUDIO_DOCUMENT_CREATE',
    SBX_STUDIO_DOCUMENT_DELETE = 'SBX_STUDIO_DOCUMENT_DELETE',
    SBX_STUDIO_DOCUMENT_EXECUTE = 'SBX_STUDIO_DOCUMENT_EXECUTE',

    SBX_STUDIO_DOCUMENT_V2 = 'SBX_STUDIO_DOCUMENT_V2',
    SBX_STUDIO_DOCUMENT_V2_READ = 'SBX_STUDIO_DOCUMENT_V2_READ',
    SBX_STUDIO_DOCUMENT_V2_EDIT = 'SBX_STUDIO_DOCUMENT_V2_EDIT',
    SBX_STUDIO_DOCUMENT_V2_CREATE = 'SBX_STUDIO_DOCUMENT_V2_CREATE',
    SBX_STUDIO_DOCUMENT_V2_DELETE = 'SBX_STUDIO_DOCUMENT_V2_DELETE',
    SBX_STUDIO_DOCUMENT_V2_EXECUTE = 'SBX_STUDIO_DOCUMENT_V2_EXECUTE',

    SBX_STUDIO_SPEECH_TO_TEXT = 'SBX_STUDIO_SPEECH_TO_TEXT',
    SBX_STUDIO_SPEECH_TO_TEXT_READ = 'SBX_STUDIO_SPEECH_TO_TEXT_READ',
    SBX_STUDIO_SPEECH_TO_TEXT_EDIT = 'SBX_STUDIO_SPEECH_TO_TEXT_EDIT',
    SBX_STUDIO_SPEECH_TO_TEXT_CREATE = 'SBX_STUDIO_SPEECH_TO_TEXT_CREATE',
    SBX_STUDIO_SPEECH_TO_TEXT_DELETE = 'SBX_STUDIO_SPEECH_TO_TEXT_DELETE',
    SBX_STUDIO_SPEECH_TO_TEXT_EXECUTE = 'SBX_STUDIO_SPEECH_TO_TEXT_EXECUTE',

    SBX_STUDIO_SPEECH_TO_TEXT_V2 = 'SBX_STUDIO_SPEECH_TO_TEXT_V2',
    SBX_STUDIO_SPEECH_TO_TEXT_V2_READ = 'SBX_STUDIO_SPEECH_TO_TEXT_V2_READ',
    SBX_STUDIO_SPEECH_TO_TEXT_V2_EDIT = 'SBX_STUDIO_SPEECH_TO_TEXT_V2_EDIT',
    SBX_STUDIO_SPEECH_TO_TEXT_V2_CREATE = 'SBX_STUDIO_SPEECH_TO_TEXT_V2_CREATE',
    SBX_STUDIO_SPEECH_TO_TEXT_V2_DELETE = 'SBX_STUDIO_SPEECH_TO_TEXT_V2_DELETE',
    SBX_STUDIO_SPEECH_TO_TEXT_V2_EXECUTE = 'SBX_STUDIO_SPEECH_TO_TEXT_V2_EXECUTE',

    SBX_STUDIO_IMAGE_GENERATOR = 'SBX_STUDIO_IMAGE_GENERATOR',
    SBX_STUDIO_IMAGE_GENERATOR_READ = 'SBX_STUDIO_IMAGE_GENERATOR_READ',
    SBX_STUDIO_IMAGE_GENERATOR_EDIT = 'SBX_STUDIO_IMAGE_GENERATOR_EDIT',
    SBX_STUDIO_IMAGE_GENERATOR_CREATE = 'SBX_STUDIO_IMAGE_GENERATOR_CREATE',
    SBX_STUDIO_IMAGE_GENERATOR_DELETE = 'SBX_STUDIO_IMAGE_GENERATOR_DELETE',
    SBX_STUDIO_IMAGE_GENERATOR_EXECUTE = 'SBX_STUDIO_IMAGE_GENERATOR_EXECUTE',

    SBX_STUDIO_IMAGE_GENERATOR_V2 = 'SBX_STUDIO_IMAGE_GENERATOR_V2',
    SBX_STUDIO_IMAGE_GENERATOR_V2_READ = 'SBX_STUDIO_IMAGE_GENERATOR_V2_READ',
    SBX_STUDIO_IMAGE_GENERATOR_V2_EDIT = 'SBX_STUDIO_IMAGE_GENERATOR_V2_EDIT',
    SBX_STUDIO_IMAGE_GENERATOR_V2_CREATE = 'SBX_STUDIO_IMAGE_GENERATOR_V2_CREATE',
    SBX_STUDIO_IMAGE_GENERATOR_V2_DELETE = 'SBX_STUDIO_IMAGE_GENERATOR_V2_DELETE',
    SBX_STUDIO_IMAGE_GENERATOR_V2_EXECUTE = 'SBX_STUDIO_IMAGE_GENERATOR_V2_EXECUTE',

    SBX_STUDIO_MARKETING_GENERATOR = 'SBX_STUDIO_MARKETING_GENERATOR',
    SBX_STUDIO_MARKETING_GENERATOR_READ = 'SBX_STUDIO_MARKETING_GENERATOR_READ',
    SBX_STUDIO_MARKETING_GENERATOR_EDIT = 'SBX_STUDIO_MARKETING_GENERATOR_EDIT',
    SBX_STUDIO_MARKETING_GENERATOR_CREATE = 'SBX_STUDIO_MARKETING_GENERATOR_CREATE',
    SBX_STUDIO_MARKETING_GENERATOR_DELETE = 'SBX_STUDIO_MARKETING_GENERATOR_DELETE',
    SBX_STUDIO_MARKETING_GENERATOR_EXECUTE = 'SBX_STUDIO_MARKETING_GENERATOR_EXECUTE',

    SBX_STUDIO_MARKETING_GENERATOR_V2 = 'SBX_STUDIO_MARKETING_GENERATOR_V2',
    SBX_STUDIO_MARKETING_GENERATOR_V2_READ = 'SBX_STUDIO_MARKETING_GENERATOR_V2_READ',
    SBX_STUDIO_MARKETING_GENERATOR_V2_EDIT = 'SBX_STUDIO_MARKETING_GENERATOR_V2_EDIT',
    SBX_STUDIO_MARKETING_GENERATOR_V2_CREATE = 'SBX_STUDIO_MARKETING_GENERATOR_V2_CREATE',
    SBX_STUDIO_MARKETING_GENERATOR_V2_DELETE = 'SBX_STUDIO_MARKETING_GENERATOR_V2_DELETE',
    SBX_STUDIO_MARKETING_GENERATOR_V2_EXECUTE = 'SBX_STUDIO_MARKETING_GENERATOR_V2_EXECUTE',
    // TEST = 'TEST',
}

export interface UserPermissions {
    id: number;
    permission: PermissionType;
    metadata: string[];
    module_name: Permissions;
}

export enum PermissionType {
    READ = 'READ',
    CREATE = 'CREATE',
    DELETE = 'DELETE',
    EDIT = 'EDIT',
    EXECUTE = 'EXECUTE',
}

export const AI_AGENT_V2_CREATE = Permissions.SBX_STUDIO_AGENT_V2_CREATE;
export const AI_AGENT_V2_EDIT = Permissions.SBX_STUDIO_AGENT_V2_EDIT;
export const AI_AGENT_V2_DELETE = Permissions.SBX_STUDIO_AGENT_V2_DELETE;

// export const AI_AGENT_V2_CREATE = Permissions.TEST;
// export const AI_AGENT_V2_EDIT = Permissions.TEST;
// export const AI_AGENT_V2_DELETE = Permissions.TEST;

export const DOCUMENT_V2_CREATE = Permissions.SBX_STUDIO_DOCUMENT_V2_CREATE;

// export const DOCUMENT_V2_CREATE = Permissions.TEST;

export const IMAGES_V2_CREATE = Permissions.SBX_STUDIO_IMAGE_GENERATOR_V2_CREATE;

// export const IMAGES_V2_CREATE = Permissions.TEST;

export const SPEECH_TO_TEXT_V2_CREATE = Permissions.SBX_STUDIO_SPEECH_TO_TEXT_V2_CREATE;

// export const SPEECH_TO_TEXT_V2_CREATE = Permissions.TEST;

export const MARKETING_V2_CREATE = Permissions.SBX_STUDIO_MARKETING_GENERATOR_V2_CREATE;

// export const MARKETING_V2_CREATE = Permissions.TEST;